import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("map", component(opts));
  editor.BlockManager.add("map", block(opts));
};